import api from "services/offers";
import * as types from "../mutation-types";

const state = {
  order_ref: null,
  cart: [],
  cartGuest: [],
  savedItems: [],
  totalCheckout: 0,
  totalSchoolingCheckout: 0,
  cartTotalCheckout: 0,
  currency: '',
  checkoutStatus: null,
  checkedout: [],
  cbcheckout: {},
  complete: [],
  canceled: [],
  messages: {},
  selectedOrder: null,
  status: null,
  status_message: null
};

const getters = {
  status: state => {
    return state.status;
  },
  statusMessage: state => {
    return state.status_message;
  },
  checkoutStatus: state => {
    return state.checkoutStatus;
  },
  cbCheckout: state => {
    return state.cbcheckout;
  },
  orderRef: state => {
    return state.order_ref;
  },
  cartChoices: state => {
    return state.cart;
  },
  cartHasChoiceItems: state => {
    return state.cart.some(choice => choice.choices.length);
  },
  cartGuestChoices: state => {
    return state.cartGuest;
  },
  savedItems: state => {
    return state.savedItems;
  },
  checkedoutOrders: state => {
    return state.checkedout;
  },
  checkedoutOrder: state => orderId => {
    return state.checkedout.find(order => order.id === orderId);
  },
  completeOrder: state => orderId => {
    return state.complete.find(order => order.id === orderId);
  },
  completeOrders: state => {
    return state.complete;
  },
  canceledOrders: state => {
    return state.canceled;
  },
  messages: state => {
    return state.messages;
  },
  totalCheckout: state => {
    return state.totalCheckout;
  },
  paymentCurrency: state => {
    return state.currency
  },
  totalSchoolingCheckout: state => {
    return state.totalSchoolingCheckout;
  },
  cartTotalCheckout: state => {
    return state.cartTotalCheckout;
  },
  candidateChoicesByCategory: state => cart => {
    let candidateCart = state.cart.find(
      candidate => candidate.candidate === cart.candidate
    );
    if (candidateCart) {
      return candidateCart.choices.map(function(offer) {
        if (offer.offer.categoryId === cart.category) {
          return offer;
        }
      });
    }
  },
  isSchoolingOrder: state => {
    return state.cart.some(function(cart) {
      return cart.choices.some(choice => choice.type === "schooling");
    });
  },
  isSchoolingOfferOrder: state => {
    return state.cart.some(function(cart) {
      return cart.choices.some(choice => choice.type === "schooling_offer");
    });
  },
  isOfferOrder: state => {
    return state.cart.some(function(cart) {
      return cart.choices.some(choice => choice.type === "offer");
    });
  },
  isSchoolingCheckedOutOrder: state => order => {
    if (order) {
      return order.choices.some(function(item) {
        return item.choices.some(item => item.type === "schooling");
      });
    }
  },
  isSchoolingOfferCheckedOutOrder: state => order => {
    if (order) {
      return order.choices.some(function(item) {
        return item.choices.some(item => item.type === "schooling_offer");
      });
    }
  },
  isOfferCheckedOutOrder: state => order => {
    if (order) {
      return order.choices.some(function(item) {
        return item.choices.some(item => item.type === "offer");
      });
    }
  },
  hasCandidateOrder: state => {
    return state.cart.some(function(cart) {
      return cart.choices.some(choice => choice.candidate !== null);
    });
  },
  hasCandidateInOrder: state => candidate => {
    return state.cart.some(function(cart) {
      return cart.choices.some(choice => choice.candidate_id === candidate.id);
    });
  },
  hasSchoolingOfferExpired: state => {
    return state.cart.some(function(cart) {
      return cart.choices.some(choice => choice.type === "schooling_offer" && moment(choice.offer.date_limit).isBefore(moment()));
    });
  },
  candidateSchooling: state => (candidate, status, order) => {
    let item = OrderByStatus(state, candidate, status, order);
    if (item) {
      return item.choices.find(
        choice => choice.type === "schooling" && choice.status === status
      );
    }
  },
  candidateTraining: state => (candidate, status, order) => {
    let item = OrderByStatus(state, candidate, status, order);
    if (item) {
      return item.choices.find(
          choice => choice.category === "training" && choice.training_id !== null && choice.status === status
      );
    }
  },
  candidateSchoolingDetails: state => (candidate, status, order) => {
    let item = OrderByStatus(state, candidate, status, order);
    if (item) {
      let schooling = item.choices.find(
        choice => choice.type === "schooling" && choice.status === status
      );
      if (schooling) {
        return schooling.application;
      }
    }
  },
  candidateSchoolingInOrder: state => (candidates, status, order) => {
    return candidates.filter(function(candidate) {
      let item = OrderByStatus(state, candidate, status, order);
      if (item) {
        let schooling = item.choices.find(
          choice => choice.type === "schooling" && choice.status === status
        );
        if (schooling) {
          return schooling.application;
        }
      }
    })[0];
  },
  candidateSchoolingChoices: state => (candidate, status, order) => {
    let item = OrderByStatus(state, candidate, status, order);
    let choices = [];
    if (item) {
      choices = item.choices.filter(
        choice => choice.type === "schooling_offer" && choice.status === status
      );
    }
    return choices.length ? choices:null
  },
  candidateOfferChoices: state => (status, order) => {
    switch (status) {
      case "pending":
        return state.cart.filter(cart => cart.type === "offer");
      case "saved":
        return state.savedItems.filter(cart => cart.type === "offer");
      case "checkedout":
        let checkedoutOrder = state.checkedout.find(o => o.id === order.id);
        return checkedoutOrder.choices.filter(cart => cart.type === "offer");
      case "complete":
        let completeOrder = state.complete.find(o => o.id === order.id);
        if (completeOrder) {
          return completeOrder.choices.filter(cart => cart.type === "offer");
        }
        break
      case "canceled":
        let canceledOrder = state.canceled.find(o => o.id === order.id);
        return canceledOrder.choices.filter(cart => cart.type === "offer");
    }
  },

  isSelectedChoice: state => choice => {
    let candidateCart = state.cart.find(
      candidate => candidate.candidate === choice.candidate.id
    );
    if (candidateCart) {
      return candidateCart.choices.find(
        offer => offer.offer && offer.offer.id === choice.offer.id
      );
    }
  },
  selectedChoice: state => choice => {
    let candidateCart = state.cart.find(
      candidate => candidate.candidate === choice.candidate.id
    );
    if (candidateCart) {
      return candidateCart.choices.find(
        offer => offer.offer && offer.offer.id === choice.offer.id
      );
    }
  },
  isSelectedSessionChoice: state => choice => {
    let candidateId = null;
    if (choice.candidate) {
      candidateId = choice.candidate.id;
    }
    let candidateCart = state.cart.find(
      candidate => candidate.candidate === candidateId
    );
    if (candidateCart) {
      return candidateCart.choices.find(
        offer => offer.session && offer.session.id === choice.session.id
      );
    }
  },
  isSelectedCandidate: state => choice => {
    let session = state.cart.find(item => item.session === choice.session);
    if (session) {
      return session.choices.find(
        item => item.candidate_id === choice.candidate.id
      );
    }
    return null
  },
  isSelectedGuestSessionChoice: state => choice => {
    let cartGuest = state.cartGuest;
    if (cartGuest) {
      return cartGuest.find(
          offer => offer.session && offer.session.id === choice.session.id
      );
    }
    return null
  },
  sessionConflict: state => choice => {
    let candidateId = null;
    if (choice.candidate) {
      candidateId = choice.candidate.id;
    }
    let candidateCart = state.cart.find(
      candidate => candidate.candidate === candidateId
    );

    let offer = candidateCart.choices.find(
      item => item.session && item.session.id === choice.choice.session.id
    );

    let begin = moment(offer.session.begin).toDate();
    let end = moment(offer.session.end).toDate();

    for (let i = 0, len = candidateCart.choices.length; i < len; i++) {
      let choice = candidateCart.choices[i];
      if (choice.session && choice.session.id !== offer.session.id) {
        let sessionBegin = moment(choice.session.begin).toDate();
        let sessionEnd = moment(choice.session.end).toDate();

        const range1 = moment.range(begin, end);
        const range2 = moment.range(sessionBegin, sessionEnd);

        return range1.overlaps(range2);
      }
    }
  },
  selectedOrder: state => {
    return state.selectedOrder;
  },

  guestOfferChoices: state => {
    return state.cartGuest;
  },

  sessionGuestConflict: state => choice => {
    let cartGuest = state.cartGuest;

    let offer = cartGuest.find(
      item => item.session && item.session.id === choice.choice.session.id
    );
    let begin = moment(offer.session.begin).toDate();
    let end = moment(offer.session.end).toDate();

    for (var i = 0, len = cartGuest.length; i < len; i++) {
      let choice = cartGuest[i];
      if (choice.session && choice.session.id !== offer.session.id) {
        let sessionBegin = moment(choice.session.begin).toDate();
        let sessionEnd = moment(choice.session.end).toDate();

        const range1 = moment.range(begin, end);
        const range2 = moment.range(sessionBegin, sessionEnd);

        return range1.overlaps(range2);
      }
    }
  }
};

function OrderByStatus(state, candidate, status, order) {
  switch (status) {
    case "pending":
      return state.cart.find(cart => cart.candidate === candidate.id);
    case "saved":
      return state.savedItems.find(cart => cart.candidate === candidate.id);
    case "checkedout":
      let checkedoutOrder = state.checkedout.find(o => o.id === order.id);
      return checkedoutOrder.choices.find(
        choice => choice.candidate === candidate.id
      );
    case "complete":
      let completeOrder = state.complete.find(o => o.id === order.id);
      if (completeOrder) {
        return completeOrder.choices.find(
            choice => choice.candidate === candidate.id
        );
      }
      break
    case "canceled":
      let canceledOrder = state.canceled.find(o => o.id === order.id);
      return canceledOrder.choices.find(
          choice => choice.candidate === candidate.id
      );
  }
}

const actions = {
  async setUserPendingCart({ state, commit }, userId) {
    commit("setCheckoutStatus", null);
    const payload = await api.pendingOrder(userId);
    if ((await payload.status) === 200 && payload.data.choices) {
      commit("pendingCart", payload.data);
      commit("setCheckoutStatus", "pending");
      commit("totalCheckOut");
    } else {
      commit("resetCart");
      commit("totalCheckOut");
    }
  },
  async setUserCheckedoutOrders({ state, commit }, userId) {
    const payload = await api.checkedoutOrders(userId);
    if ((await payload.status) === 200) {
      commit("checkedoutOrders", payload.data);
    }
  },
  async setUserCompleteOrders({ state, commit }, userId) {
    const payload = await api.completeOrders(userId);
    if ((await payload.status) === 200) {
      commit("completeOrders", payload.data);
    }
  },
  async setUserCanceledOrders({ state, commit }, userId) {
    const payload = await api.canceledOrders(userId);
    if ((await payload.status) === 200) {
      commit("canceledOrders", payload.data);
    }
  },
  async setUserSavedItems({ state, commit }, userId) {
    const payload = await api.savedOrderItems(userId);
    if ((await payload.status) === 200 && payload.data) {
      commit("savedItems", payload.data);
      commit("totalCheckOut");
    }
  },
  async addChoiceToCart({ state, commit }, choice) {
    const payload = await api.addChoiceToCart({
      candidate: choice.candidate.id,
      offer: choice.offer.id,
      school: choice.school.id
    });
    if ((await payload.status) === 200) {
      commit("pushChoiceToCart", {
        id: choice.candidate.id,
        offer: payload.data,
        school: choice.school.id
      });
      commit("setCheckoutStatus", "pending");
      commit("totalCheckOut");
    }
  },
  async saveChoice({ state, commit }, choice) {
    const payload = await api.saveChoice({
      candidate: choice.candidate.id,
      choice: choice.choice.id,
      school: choice.school.id
    });
    if ((await payload.status) === 200) {
      commit("pendingCart", payload.data.order);
      commit("setCheckoutStatus", "pending");
      commit("savedItems", payload.data.savedItems);
      commit("totalCheckOut");
    }
  },
  async restoreChoice({ state, commit }, choice) {
    const payload = await api.restoreChoice({
      candidate: choice.candidate.id,
      choice: choice.choice.id,
      school: choice.school.id
    });
    if ((await payload.status) === 200) {
      commit("pendingCart", payload.data.order);
      commit("setCheckoutStatus", "pending");
      commit("savedItems", payload.data.savedItems);
      commit("totalCheckOut");
    }
  },
  async addAdditionnalChoiceToCart({ state, commit }, choice) {
    const payload = await api.addChoiceToCart({
      candidate: choice.candidate.id,
      offer: choice.offer.id,
      school: choice.school.id,
      type: 'offer'
    });
    if ((await payload.status) === 200) {
      commit("pushAdditionnalChoiceToCart", {
        id: choice.candidate.id,
        offer: payload.data,
        school: choice.school.id,
        type: 'offer'
      });
      commit("setCheckoutStatus", "pending");
      commit("totalCheckOut");
      commit("setStatus", await payload.status);
    }
  },
  async addFreeSessionToCart({ state, commit }, choice) {
    const payload = await api.addChoiceToCart({
      candidate: choice.candidate.id,
      offer: choice.offer.id,
      school: choice.school.id,
      date: choice.date
    });
    if ((await payload.status) === 200) {
      commit("pushFreeSessionToCart", {
        id: choice.candidate.id,
        offer: payload.data,
        school: choice.school.id,
        date: choice.date
      });
      commit("setCheckoutStatus", "pending");
      commit("totalCheckOut");
      commit("setStatus", await payload.status);
    }
  },
  async removeFreeSessionFromCart({ state, commit }, choice) {
    const payload = await api.removeChoiceFromCart({
      candidate: choice.candidate,
      choice: choice.choice.id
    });
    if ((await payload.status) === 200) {
      commit("spliceAdditionnalChoiceFromCart", {
        id: choice.candidate.id,
        choice: choice.choice
      });
      commit("totalCheckOut");
    }
  },
  async addSessionChoiceToCart({ state, commit }, choice) {
    const payload = await api.addChoiceToCart({
      candidate: choice.candidate.id,
      offer: choice.offer.id,
      school: choice.school.id,
      offer_session: choice.session.id,
      type: choice.type
    });
    if ((await payload.status) === 200) {
      commit("pushSessionChoiceToCart", {
        id: choice.candidate.id,
        offer: payload.data,
        school: choice.school.id,
        offer_session: choice.session.id,
        type: choice.type
      });
      commit("setCheckoutStatus", "pending");
      commit("totalCheckOut");
    }
  },
  async removeSessionChoiceFromCart({ state, commit }, choice) {
    const payload = await api.removeSessionChoiceFromCart({
      session: choice.session,
      choices: choice.choices
    });
    if ((await payload.status) === 200) {
      commit("spliceSessionChoiceFromCart", {
        id: choice.session,
        choices: choice.choices
      });
      if (payload.data.choices) {
        commit("pendingCart", payload.data);
        commit("setCheckoutStatus", "pending");
      }
      commit("totalCheckOut");
    }
  },
  async addGuestChoiceToCart({ state, commit }, choice) {
    const payload = await api.addChoiceToCart({
      candidate: choice.candidate.id,
      offer: choice.offer.id,
      school: choice.school.id,
      offer_session: choice.session.id,
      type: choice.type
    });
    if ((await payload.status) === 200) {
      commit("pushSessionChoiceToCart", {
        id: choice.candidate.id,
        offer: payload.data,
        school: choice.school.id,
        offer_session: choice.session.id,
        type: choice.type
      });
      commit("spliceChoiceFromGuestCart", choice);
      commit("setCheckoutStatus", "pending");
      commit("totalCheckOut");
    }
  },
  async removeChoiceFromCart({ state, commit }, choice) {
    const payload = await api.removeChoiceFromCart({
      candidate: choice.candidate.id,
      choice: choice.choice.id
    });
    if ((await payload.status) === 200) {
      commit("spliceChoiceFromCart", {
        id: choice.candidate.id,
        choice: choice.choice
      });
      commit("totalCheckOut");
    }
  },
  async removeCandidateChoiceFromSession({ state, commit }, choice) {
    let session = state.cart.find(item => item.session === choice.session);
    if (session) {
      let candidateChoice = session.choices.find(
        item => item.candidate_id === choice.candidate.id
      );
      const payload = await api.removeChoiceFromCart({
        candidate: choice.candidate.id,
        choice: candidateChoice.id,
        school:  choice.school.id
      });
      if ((await payload.status) === 200) {
        commit("spliceCandidateFromSession", {
          session: session,
          choice: candidateChoice
        });
        if (payload.data.choices) {
          commit("pendingCart", payload.data);
          commit("setCheckoutStatus", "pending");
        }
        commit("totalCheckOut");


      }

    }
  },
  async addChoiceToGuestCart({ state, commit }, choice) {
    commit("pushChoiceToGuestCart", {
      id: choice.candidate,
      offer: choice.offer,
      school: choice.school.id,
      offer_session: choice.session
    });
    commit("setCheckoutStatus", "pending");
    commit("totalCheckOut");
  },
  async removeGuestChoiceFromCart({ state, commit }, choice) {
    commit("spliceChoiceFromGuestCart", choice.choice);
    commit("totalCheckOut");
  },
  async resetGuestCart({ state, commit }) {
    commit("resetGuestCart");
    commit("totalCheckOut");
  },
  async orderCheckout({ commit }, order) {
    const payload = await api.orderCheckout(order);
    if ((await payload.status) === 200) {
      commit("selectOrder", await payload.data);
      commit("pushToCheckedoutOrders", await payload.data);
      commit("resetCart");
      commit("setCheckoutStatus", "checkedout");
    }
    commit("setStatus", await payload.status);

    if (await payload.data.message) {
      commit("setStatusMessage", await payload.data.message);
    }

  },
  async confirmOrderPayment({ commit }, order) {
    const payload = await api.confirmOrderPayment(order);
    if ((await payload.status) === 200) {
      commit("selectOrder", await payload.data);
      commit("updateOrder", await payload.data);
    }
  },
  async fetchCBCheckout({ commit }, order) {
    const payload = await api.fetchCBCheckout(order);
    if ((await payload.status) === 200) {
      commit("cbCheckedOutOrder", await payload.data);
    }
  },
  async saveOrderPayments({ commit }, checks) {
    const payload = await api.saveOrderPayments(checks);
    if ((await payload.status) === 200) {
      commit("updateOrder", await payload.data);
    }
  },
  async saveTotalCheckout({ commit }, checks) {
    const payload = await api.saveTotalCheckout(checks);
    if ((await payload.status) === 200) {
      commit("updateOrder", await payload.data);
    }
  },
  async orderComplete({ commit }, order) {
    const payload = await api.orderComplete(order);
    if ((await payload.status) === 200) {
      commit("updateCheckedOutOrder", await payload.data);
    }
  },
  async updateOfferSession({ commit }, choice) {
    const payload = await api.updateOfferSession(choice);
    if ((await payload.status) === 200) {
      commit("updateOrder", await payload.data);
    }
  },
  async cancelSessionRegistration({ commit }, choice) {
    const payload = await api.cancelSessionRegistration(choice);
    if ((await payload.status) === 200) {
      commit("updateOrder", await payload.data);
    }
  },
  async orderDelete({ commit }, order) {
    const payload = await api.orderDelete(order);
    if ((await payload.status) === 200) {
      commit("deleteOrder", await payload.data);
    }
    commit("setStatus", await payload.status);
  },
  async orderCancel({ commit }, order) {
    const payload = await api.orderCancel(order);
    if ((await payload.status) === 200) {
      commit("cancelOrder", await payload.data);
    }
    commit("setStatus", await payload.status);
  },
  async selectOrder({ commit }, order) {
    commit("selectOrder", order);
  },
  async fetchMessages({ commit }, user) {
    const payload = await api.fetchMessages(user);
    if ((await payload.status) === 200) {
      commit("setMessages", await payload.data);
    }
  },
  async sendMessage({ commit }, message) {
    const payload = await api.sendMessage(message);
    if ((await payload.status) === 200) {
      commit("sendMessage", await payload.data);
    }
  },
  async replyMessage({ commit }, message) {
    const payload = await api.sendMessage(message);
    if ((await payload.status) === 200) {
      commit("replyMessage", await payload.data);
    }
  }
};

const mutations = {
  pendingCart(state, cart) {
    state.order_ref = cart.id;
    state.cart = cart.choices;
    state.checkoutStatus = cart.checkoutStatus;
    state.currency = cart.payment_currency;
  },
  resetCart(state) {
    state.cart = [];
    state.totalCheckout = 0;
  },
  resetGuestCart(state) {
    state.cartGuest = [];
    state.totalCheckout = 0;
  },
  resetOrders(state) {
    state.order_ref = null;
    state.cart = [];
    state.cartGuest = [];
    state.savedItems = [];
    state.checkedout = [];
    state.complete = [];
    state.selectedOrder = null;
    state.totalCheckout = 0;
  },
  checkedoutOrders(state, orders) {
    state.checkedout = orders;
  },
  completeOrders(state, orders) {
    state.complete = orders;
  },
  canceledOrders(state, orders) {
    state.canceled = orders;
  },
  savedItems(state, items) {
    state.savedItems = items;
  },
  selectOrder(state, order) {
    state.selectedOrder = order;
  },
  updateOrder(state, order) {
    state.complete = [
      order,
      ...state.complete.filter(element => element.id !== order.id)
    ];
  },
  cancelOrder(state, order) {
    let completeOrder = state.complete.find(o => o.id === order.id);
    state.complete.splice(state.complete.indexOf(completeOrder), 1);
    state.canceled = [
      order,
      ...state.canceled.filter(element => element.id !== order.id)
    ];
  },
  deleteOrder(state, order) {
    let checkedoutOrder = state.checkedout.find(o => o.id === order.id);
    state.checkedout.splice(state.checkedout.indexOf(checkedoutOrder), 1);
  },
  updateCheckedOutOrder(state, order) {
    let checkedoutOrder = state.checkedout.find(o => o.id === order.id);
    checkedoutOrder.order_status = "complete";
    state.complete = [
      order,
      ...state.complete.filter(element => element.id !== order.id)
    ];
  },
  cbCheckedOutOrder(state, payload) {
    state.cbcheckout = payload;
  },
  pushChoiceToCart(state, { id, offer, school }) {
    let candidate = state.cart.find(cart => cart.candidate === id);
    state.order_ref = offer.order_id;
    if (!candidate) {
      state.cart.push({
        candidate: id,
        school: school,
        choices: [offer]
      });
    } else {
      if (!candidate.choices.find(o => o.id === offer.id)) {
        candidate.choices.push(offer);
      }
    }
  },
  pushAdditionnalChoiceToCart(state, { id, offer, school }) {
    let candidate = state.cart.find(cart => cart.candidate === id);
    state.order_ref = offer.order_id;
    state.cart.push({
      candidate: id,
      school: school,
      type: "offer",
      choices: [offer]
    });
  },
  pushFreeSessionToCart(state, { id, offer, school, date }) {
    let candidate = state.cart.find(cart => cart.candidate === id);
    state.order_ref = offer.order_id;
    state.cart.push({
      candidate: id,
      school: school,
      date: date,
      type: "offer",
      choices: [offer]
    });
  },
  pushSessionChoiceToCart(state, { id, offer, school, offer_session }) {
    let session = state.cart.find(cart => cart.session === offer_session);
    state.order_ref = offer.order_id;
    if (!session) {
      state.cart.push({
        session: offer_session,
        school: school,
        type: "offer",
        choices: [offer]
      });
    } else {
      if (!session.choices.find(o => o.candidate_id === id)) {
        session.choices.push(offer);
      }
    }
  },

  pushChoiceToGuestCart(state, { id, offer, school, offer_session }) {
    let choiceOffer = {};

    choiceOffer.candidate_id = null;
    choiceOffer.id = null;
    choiceOffer.school = school;
    choiceOffer.price = offer.price;
    choiceOffer.offer = JSON.parse(JSON.stringify(offer));
    choiceOffer.session = offer_session;
    choiceOffer.status = "pending";
    choiceOffer.type = "offer";
    state.cartGuest.push(choiceOffer);
  },
  pushToCheckedoutOrders(state, order) {
    state.checkedout = [
      order,
      ...state.checkedout.filter(element => element.id !== order.id)
    ];
  },
  spliceChoiceFromGuestCart(state, choice) {
    let guestItem = state.cartGuest.find(
      item => item.session.id === choice.session.id
    );
    state.cartGuest.splice(state.cartGuest.indexOf(guestItem), 1);
  },
  spliceChoiceFromCart(state, { id, choice }) {
    let candidate = state.cart.find(candidate => candidate.candidate === id);
    let item = candidate.choices.find(item => item.id === choice.id);
    candidate.choices.splice(candidate.choices.indexOf(item), 1);
    if (!candidate.choices.length) {
      state.cart.splice(state.cart.indexOf(candidate), 1);
    }
  },
  spliceAdditionnalChoiceFromCart(state, { id, choice }) {
    state.cart.map(function(cartItem) {
      if (cartItem.choices.find(item => item.id === choice.id)) {
        state.cart.splice(state.cart.indexOf(cartItem), 1);
      }
    });
  },
  spliceCandidateFromSession(state, { session, choice }) {
    if (session.choices.length === 1) {
      let choiceOffer = {};

      choiceOffer.candidate_id = null;
      choiceOffer.id = null;
      choiceOffer.price = choice.price;
      choiceOffer.offer = JSON.parse(JSON.stringify(choice.offer));
      choiceOffer.session = choice.session;
      choiceOffer.status = "pending";
      choiceOffer.type = "offer";

      state.cartGuest.unshift(choiceOffer);
    }

    session.choices.splice(session.choices.indexOf(choice), 1);
  },
  spliceSessionChoiceFromCart(state, { id }) {
    let session = state.cart.find(item => item.session === id);
    state.cart.splice(state.cart.indexOf(session), 1);
  },
  totalCheckOut(state) {
    state.totalCheckout = 0;
    state.totalSchoolingCheckout = 0;
    state.cartTotalCheckout = 0;
    state.cart.map(function(candidateCart) {
      if (candidateCart.choices) {
        candidateCart.choices.map(function(choice) {
          state.totalCheckout += choice.price;
          state.cartTotalCheckout += choice.price;
          if (choice.type === "schooling") {
            state.totalSchoolingCheckout += choice.price;
          }
          if (choice.type === "schooling" && choice.application.internship_choice) {
            state.totalCheckout += choice.application.school_disbursement;
            state.cartTotalCheckout += choice.application.school_disbursement;
          }
        });
      }
    });

    state.cartGuest.map(function(choice) {
      state.totalCheckout += choice.price;
    });
  },
  setCheckoutStatus(state, status) {
    state.checkoutStatus = status;
  },
  setStatus(state, status) {
    state.status = status;
  },
  setStatusMessage(state, message) {
    state.status_message = message;
  },
  setMessages(state, payload) {
    state.messages = payload;
  },
  sendMessage(state, payload) {
    state.messages.push(payload);
  },
  replyMessage(state, payload) {
    let message = state.messages.find(message => message.id === payload.id);
    const index = state.messages.indexOf(message);
    state.messages[index] = payload;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
